import React from "react";
// import { domain, headers, contentUrl } from '../../Variables'
import Loader from 'react-loader-spinner'
import HttpServices from "../../utils/Http.services";
import { translate } from "../../utils/useful";
// import { lngTranslations } from "../../utils/useful";
// import { transform } from "lodash";
// import SelectWithSearch from "./SelectWithSearch";
// import { imageAddress } from "../../utils/useful";



class AdvancedMultiTreeSelectAddListing extends React.Component {

    state = {
        selected: '',
        subCheckCount: [],
        subCheck: [],
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        mainParents: [],
        isLoading: true,
        value: '',
        openRow: {},

    }

    toggleOpen = (makeOpen) => {

        let final = makeOpen != null ? makeOpen : !this.state.isOpen
        if (final != this.state.isOpen) {
            if (!this.state.isOpen) {
                document.addEventListener('mousedown', this.closeBox);
            } else {
                document.removeEventListener('mousedown', this.closeBox);
            }
        }
        // if (this.refs.icon)
        //     this.refs.icon.classList.toggle("rotate-180")


        this.setState({ isOpen: final, data: this.props.data }, () => {
            this.changePositionOnOpen()

        })

    }

    closeOptions() {
        document.removeEventListener('mousedown', this.closeBox);
        if (this.refs.icon)
            this.refs.icon.classList.toggle("rotate-180")

        this.setState({ isOpen: false, data: this.props.data })
    }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            if (this.refs.icon)
                this.refs.icon.classList.toggle("rotate-180")

        }
    }
    changeItem = (prop) => {
        this.setState({ value: prop.title, isOpen: false })
        // this.closeOptions()
        if (this.state.tempData.length > 0) {
            this.setState({ options: this.state.tempData })
        }

        let parent = prop.parent?._id
        let parents = [prop.value]

        this.getParent(parent, parents, () => {

            this.props.changeValue(this.props.header.key, prop.value, prop.withOperator, prop.flexible, parents)


        })




    }


    getParent(parent, parents, cb) {

        if (parent == null) {
            parents = []
            cb()
        } else {
            let found = false

            let tempData = this.state.tempData
            if (tempData.length == 0) {
                tempData = this.state.options
            }
            tempData.forEach(element => {


                if (element._id == parent) {
                    found = true
                    parents.splice(0, 0, element?._id)

                    if (element.parent == null) {
                        cb()
                    } else {
                        this.getParent(element.parent?._id, parents, cb)
                    }
                }

            });

            if (found == false) {
                cb()
            }

        }
    }

    setDefault() {
        if (this.props.data && this.props.data.title) {
            this.setState({ value: "" })
            this.state.options.forEach(option => {
                if (option.value == this.props.data._id) {
                    this.setState({ value: option.title })
                    this.props.changeValue(this.props.header.key, this.props.data.title, option.withOperator, option.flexible)
                    return
                }
            });



        }
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentWillMount() {
        // if(this.props.title){
        //     this.setState({value:this.props.title})
        // }
        this.init()

    }

    componentWillReceiveProps(newProp) {
        if (this.props.title != newProp.title) {
            this.init()

        }
    }

    init() {
        if (this.props.header.information) {
            if (this.props.header.information.type == "local") {
                this.setState({ options: this.props.header.information.items }, () => {
                })
            } else if (this.props.header.information.type == "api") {
                this.fetch()
                // this.setState({data:[]})
            }
        }
    }


    fetch() {
        this.setState({ isLoading: true })
        let mainParents = this.state.mainParents
        let parentBody = this.props.header.information.body ?? {}
        let body = this.props.header.information.body ?? {}
        parentBody.filter = this.props.header.information.parentFilter
        body.filter = this.props.header.information.filter
        if (this.props.header.information.select) {
            body.select = this.props.header.information.select
        }
        if (this.props.header.information.sort) {
            body.sort = this.props.header.information.sort
        }
        HttpServices.request(this.props.header.information.parentAddress, parentBody, (mainParents, fetchError) => {
            HttpServices.request(this.props.header.information.address, body, (data, fetchError) => {
                this.setState({ isLoading: false })
                if (fetchError) {
                    this.setState({ fetchError })
                    return
                }
                var newData = []
                console.log('data.infodata.info', data.info)
                // for (let i = 0; i < mainParents.info.length; i++) {
                //     const standard = mainParents.info[i];

                data.info.forEach(element => {
                    let newTitle
                    let newValue
                    let newParent
                    let mainParent
                    let withOperator
                    let flexible
                    let translations
                    if (this.props.header.information.fields.mainParent) {
                        mainParent = this.spliter(element, this.props.header.information.fields.mainParent)
                        // if (mainParents.length > 0 && mainParents.includes(mainParent)) {

                        //     }
                        // else {
                        //     mainParents.push(mainParent)
                        // }
                    }

                    if (this.props.header.information.fields.value) {
                        newValue = this.spliter(element, this.props.header.information.fields.value)
                    }
                    if (this.props.header.information.fields.parent) {
                        newParent = this.spliter(element, this.props.header.information.fields.parent)
                    }
                    if (this.props.header.information.fields?.title) {
                        newTitle = this.spliter(element, this.props.header.information.fields?.title)
                    }
                    if (this.props.header.showKey) {
                    }
                    let newImage = null
                    if (this.props.header.information.fields.image) {
                        newImage = this.spliter(element, this.props.header.information.fields.image)
                    }
                    newData.push({ value: newValue, title: newTitle, image: newImage, parent: newParent, _id: element._id, withOperator, flexible, '**translations': translations, mainParent: mainParent, })
                });

                // }
                this.setState({
                    options: newData,
                    tempData: newData,
                    mainParents: mainParents.info,
                    isLoading: false
                }, () => {
                    this.setDefault()
                })
            })
        })
    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }


    search = async (value) => {

        this.toggleOpen(true)

        let options = this.state.tempData


        if (value == "") {
            await this.setState({ options: this.state.tempData, searchOptions: null })
            await this.setState({ tempData: [], isSearching: false })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
                options = this.state.options
            }
            var values = []
            // let options = this.state.tempData
            // var values = this.props.data.filter((e) => e.title === value)
            options.forEach(element => {
                if (element?.title.toLowerCase().includes(value.toLowerCase()) || (translate(element, 'title') && translate(element, 'title').toLowerCase().includes(value.toLowerCase()))) {

                    let found = false

                    options.forEach(child => {
                        if (child.parent?._id == element._id) {

                            found = true
                        }
                    });

                    if (found == false) {
                        values.push(element)
                    }
                }
            })

            this.setState({ options: values, isSearching: true })
            this.setState({ searchOptions: values })

            // }
        }
    }



    componentDidMount() {
        window.addEventListener('scroll', this.changePositionOnOpen, true);
        window.addEventListener('resize', this.changePositionOnOpen, true);

    }


    componentWillUnmount() {

        // this.window.removeEventListener('scroll', this.changePositionOnOpen, true);
        // this.window.removeEventListener('resize', this.changePositionOnOpen, true);

        if (this.unlisten)
            this.unlisten();
    }



    setWrapperRef(node) {
        this.wrapperRef = node;
    }



    changePositionOnOpen = () => {
        if (this.wrapperRef) {
            let bounds = this.wrapperRef.getBoundingClientRect()


            if (this.refs.box) {
                let boxBounds = this.refs.box.getBoundingClientRect()



                this.setState({ top: bounds.y + bounds.height, width: bounds.width, left: bounds.x }, () => {
                })
            }
        }
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }
    showSub(prop) {

        this.state.subCheck[prop._id] = !this.state.subCheck[prop._id] ?? true;
        this.setState({ subCheck: this.state.subCheck })
    }



    countCalculator() {

        // if (this.state.tempData.length > 0)
        //     this.setState({ options: this.state.tempData })


        for (let i in this.state.options) {
            let id = this.state.options[i]._id
            if ((typeof (this.state.subCheckCount[this.state.options[i]._id]) == 'number')) {
                break;
            }
            for (let j in this.state.options) {
                if (this.state.options[j].parent?._id == id) {
                    this.state.subCheckCount[id] = 1;
                    this.setState({ subCheckCount: this.state.subCheckCount });
                    break;

                }
            }
        }
    }

    liActive(id) {
        let l = [];
        l[id] = true;


        this.setState({ brandCheck: l });
    }

    selectedMnu(id) {

        // this.state.selected = [];
        // this.state.selected[id] = 1;
        this.setState({ selected: id })
    }


    modelNotListed = () => {
        this.props.modelNotListed()
    }
    setRow = (mainParent) => {
        let openRow = this.state.openRow
        if(!openRow[mainParent._id]){
            openRow[mainParent._id] = true
        }else{

            openRow[mainParent._id] = false
        }
        this.setState({})
    }


    loadRow(parent, paddingLeft, standardParent) {

        return this.state.options.map((prop, index) => {
            console.log('prop', prop);
            let letShow = false
            let mparent = prop.parent?._id ?? prop.parent
            let mainParent = prop.mainParent
            if (mparent == '' || mparent == null) {
                let parents = this.state.options.filter((a) => { return ((String(a._id) == String(mparent)) && a.parent != null) })
                if (parents.length == 0) {
                    letShow = false
                }
            }
            if ((this.state.searchOptions != null)) {
                letShow = true
            }
            if ((mparent == parent)) {
                letShow = true
            }
            if (this.state.subCheckCount[prop._id] && this.state.isSearching) {
                letShow = false
            }
            // console.log('ttttttttttttt', standardParent._id);
            // console.log('ttttttttttttt', mainParent);
            if (letShow && standardParent._id == mainParent) {
                return (
                    <div style={{ paddingLeft: paddingLeft, marginTop: 0, marginBottom: 0, paddingTop: '0px' }}>
                        <div className="select-item-addlisting" key={index} style={{ backgroundColor: (this.state.selected == prop._id) ? '#FFF3DB' : 'transparent', alignItems: 'center', borderBottomColor: '#f2f4f6', borderBottomStyle: 'solid', borderBottomWidth: 0, borderTop: paddingLeft == 0 ? '1px solid #f2f4f6' : 'none', borderRight: 0, paddingTop: '10px', paddingBottom: '10px' }}>
                            <div className="d-flex" style={{ alignItems: 'center', justifyContent: 'space-between', paddingRight: (paddingLeft / 2) }}>
                                <div className="flexcb w-100" onClick={() => { this.changeItem(prop) }} style={{ padding: '5px 10px 5px 20px', display: 'flex', gap: '5px', cursor: 'pointer', width: '90%', }}>
                                    {/* {(true) ? <img src={prop.image} width='25px' /> : ''} */}
                                    <p className="d-flex flex-column" style={{ margin: 0, color: this.state.subCheckCount[prop._id] ? '#202020' : '#101010', fontSize: paddingLeft == 0 ? 14 : 12, fontWeight: this.state.subCheckCount[prop._id] ? 'normal' : 'normal', textAlign: 'start' }}>
                                        {prop.title}
                                    </p>
                                </div>
                            </div>
                        </div>
                        {this.state.subCheck[prop._id] && this.state.searchOptions == null && this.loadRow(prop._id, paddingLeft + 8, standardParent)}
                    </div>
                )
            }
        })



    }

    render() {
        return (
            <div ref={ref => this.setWrapperRef(ref)} className='' style={{ paddingRight: 2, paddingTop: 2, width: '100%', minWidth: '200px', position: 'relative' }} >
                {this.countCalculator()}
                <div className="d-flex" style={{ cursor: 'pointer', alignItems: 'center', color: '#fff !important', paddingLeft: 10, height: 30, flex: 1, width: '100%', borderRadius: 10, borderStyle: 'none', fontSize: 13, padding: '0px' }}>
                    {this.props.icon && (
                        <img className="ml-1 mr-1" src={this.props.icon} style={{ height: 25, objectFit: 'contain' }} />
                    )}
                    <input disabled={this.conditionalSettings('disabled', true)} value={this.state.value} onFocus={() => this.toggleOpen(true)} placeholder={this.props.placeholder} onInput={event => { this.search(event.target.value); this.setState({ value: event.target.value }) }} className='mediumiransansfont ' defaultValue={this.state.title} style={{ color: '#323232', padding: 5, flex: 1, width: '100%', borderStyle: 'none', fontSize: 15, background: 'transparent' }} />
                </div>
                {this.state.isOpen && (
                    <div className="scroll-bug menuSld" ref={"box"} style={{ display: 'flex', flexDirection: 'column', top: this.state.top, left: this.state.left, position: 'fixed', width: this.state.width, zIndex: 40, paddingTop: 5 }}>
                        <div className={'row m-0'} style={{ display: 'flex', width: '100%', backdropFilter: 'blur(10px)', borderColor: '#eee', borderRadius: 6, maxHeight: 400, overflow: 'auto', paddingTop: 5, paddingBottom: 15, backgroundColor: "#fff", borderRadius: 10, boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', padding: '20px' }}>
                            <div class={(this.props.twoPart ? 'col-8' : 'col-12 p-0')} style={{ display: 'flex', flexDirection: 'column', position: 'relative', left: (this.props.twoPart ? '15px' : 0), top: '0px' }}>
                                {this.state.mainParents.map((standardParent, i) => {
                                    return (
                                        <div style={{ paddingLeft: 0, marginTop: 0, marginBottom: 0, paddingTop: '0px' }}>
                                            <div className="select-item-addlisting" key={i} style={{ backgroundColor: 'transparent', alignItems: 'center', borderBottomColor: '#f2f4f6', borderBottomStyle: 'solid', borderBottomWidth: 0, borderRight: 0, paddingBottom: '10px' }}>
                                                <div className="d-flex" style={{ alignItems: 'center', justifyContent: 'space-between', }}>
                                                    <div className="flexcb w-100" onClick={() => { this.setRow(standardParent) }} style={{ padding: '5px 10px 5px 20px', display: 'flex', gap: '5px', cursor: 'pointer', width: '90%', }}>
                                                        {/* {(true) ? <img src={prop.image} width='25px' /> : ''} */}
                                                        <p className="d-flex flex-column" style={{ margin: 0, color: '#101010', fontSize: 14, fontWeight: 'normal', textAlign: 'start' }}>
                                                            {standardParent.title}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.openRow[standardParent._id] && (
                                                <>
                                                    {this.loadRow(null, 0, standardParent)}
                                                </>
                                            )}
                                        </div>
                                    )

                                })}
                            </div>
                            {this.state.options.length != 0 && this.props.twoPart && (
                                <div class='col-4 ' style={{ backgroundColor: '#F9F9F9', alignItems: 'center', border: '0px solid', position: 'sticky', top: "25px", padding: '20px', overflow: 'auto' }}>
                                    <div style={{ color: '#949A9E', backgroundColor: 'transparent', fontSize: '14px', fontWeight: '400', fontFamily: "Poppins", display: 'flex', alignItems: 'center' }}>
                                        <div style={{ paddingRight: '10px' }}>Select Model</div>
                                        <div style={{ fontSize: '10px', color: '#000', backgroundColor: '#FFF0BE', padding: '2px 8px 2px 8px', border: 0, borderRadius: '20px' }}>Fast Listing</div>
                                    </div>
                                    <br />
                                    <div style={{ color: '#0091FD', padding: '0 0 10px 10px' }}>
                                        + Model not listed
                                    </div>
                                </div>)
                            }
                            {
                                this.state.options.length == 0 && !this.state.isLoading && (
                                    <div className="col-12">
                                        <p style={{ margin: 0, color: '#323232', opacity: 1, fontSize: 14, textAlign: 'center', backgroundColor: '#fff' }}>{translate("Found Nothing")}</p>
                                    </div>
                                )
                            }
                            {
                                this.state.isLoading && (
                                    <div className="flexcc py-3" style={{}}>
                                        <Loader
                                            type="Oval"
                                            color="rgb(255, 197, 0)"
                                            height="40"
                                            width="40"
                                        />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                )}
            </div>
        );
    }
}


export default AdvancedMultiTreeSelectAddListing;
